import { Module } from "module"
import { type } from "os"


type MatchNul = "MatchNul"
enum Joueur {
    JoueurHumain = "JoueurHumain",
    Ordinateur = "Ordinateur"
}

export enum PFC  {
    Rock = "Rock",
    Paper = "Paper",
    Scissors = "Scissors"
};

export enum PFCLS {
    Rock = "Rock",
    Paper = "Paper",
    Scissors = "Scissors" ,
    Lizard = "Lezard",
    Spock = "Spoke"
}

export enum Poke {
    Bulbasaur  = "Bulbizard",
    Squirtle = "Carapuce",
    Charmander  = "Salameche",
}


type Mode = PFC | PFCLS | Poke
type AGame<Mode>  =  { playerChoice : Mode, computerChoice : Mode , winner : Joueur|MatchNul , scoreJoueur : number}
//Un exemple
let x : AGame<PFC> = {playerChoice : PFC.Rock,computerChoice : PFC.Rock, winner : "MatchNul",scoreJoueur:0}


export function comparePFC(j1 : PFC, j2 : PFC) : number{
    if (j1 === PFC.Rock && j2 === PFC.Paper){return -1}
    if (j1 === PFC.Paper && j2 === PFC.Scissors){return -1}
    if (j1 === PFC.Scissors && j2 === PFC.Rock){return -1}
    if (j1 === j2) {return 0}
    else return 1
}

export function comparePFCLS(j1 : PFCLS, j2 : PFCLS) : number{
    if (j1 === PFCLS.Rock && j2 === PFCLS.Paper){return -1}
    if (j1 === PFCLS.Paper && j2 === PFCLS.Scissors){return -1}
    if (j1 === PFCLS.Scissors && j2 === PFCLS.Rock){return -1}
    if (j1 === PFCLS.Rock && j2 === PFCLS.Spock){return -1}
    if (j1 === PFCLS.Paper && j2 === PFCLS.Lizard){return -1}
    if (j1 === PFCLS.Scissors && j2 === PFCLS.Lizard){return -1}
    if (j1 === PFCLS.Lizard && j2 === PFCLS.Rock){return -1}
    if (j1 === PFCLS.Lizard && j2 === PFCLS.Scissors){return -1}
    if (j1 === PFCLS.Spock && j2 === PFCLS.Lizard){return -1}
    if (j1 === PFCLS.Spock && j2 === PFCLS.Paper){return -1}
    if (j1 === j2) {return 0}
    else return 1
}

export function comparePoke(j1 : Poke , j2 : Poke) : number{
    if (j1 === Poke.Bulbasaur  && j2 === Poke.Charmander ){return -1}
    if (j1 === Poke.Charmander  && j2 === Poke.Squirtle){return -1}
    if (j1 === Poke.Squirtle && j2 === Poke.Bulbasaur ){return -1}
    if (j1 === j2) {return 0}
    else return 1
}

export function reglesPFC (j1 : PFC , j2 : PFC)  : string {
    if (j1 === PFC.Rock && j2 === PFC.Paper){return "Rock is covered by paper" }
    if (j1 === PFC.Paper && j2 === PFC.Scissors){return "Paper is cut by scissors" }
    if (j1 === PFC.Scissors && j2 === PFC.Rock){return "Scissors are broken by rock"}
    if (j1 === j2) {return "Equality"}
    if (j1 === PFC.Rock && j2 === PFC.Scissors){ return "Rock crushes scissors."}
    if (j1 === PFC.Paper && j2 === PFC.Rock){return "Paper covers rock"}
    if (j1 === PFC.Scissors && j2 === PFC.Paper){return "Scissors cuts paper"}
    else return ""      
}
  
export function reglesPFCLS (j1 : PFCLS , j2 : PFCLS)  : string {
    if (j1 === PFCLS.Rock && j2 === PFCLS.Paper){return "Rock is covered by paper" }
    if (j1 === PFCLS.Paper && j2 === PFCLS.Scissors){return "Paper is cut by scissors" }
    if (j1 === PFCLS.Scissors && j2 === PFCLS.Rock){return "Scissors are broken by rock"}
    if (j1 === PFCLS.Rock && j2 === PFCLS.Scissors){ return "Rock crushes scissors."}
    if (j1 === PFCLS.Paper && j2 === PFCLS.Rock){return "Paper covers rock"}
    if (j1 === PFCLS.Scissors && j2 === PFCLS.Paper){return "Scissors cuts paper"}

    if (j1 === PFCLS.Rock && j2 === PFCLS.Spock){return "Rock is vaporized by Spock"}
    if (j1 === PFCLS.Paper && j2 === PFCLS.Lizard){return "Paper is eaten by lizard"}
    if (j1 === PFCLS.Scissors && j2 === PFCLS.Spock){return "Scissors are smashed by Spock"}
    if (j1 === PFCLS.Lizard && j2 === PFCLS.Rock){return "Lizard is crushed by rock"}
    if (j1 === PFCLS.Spock && j2 === PFCLS.Lizard){return "Spock is poisoned by lizard"}
    if (j1 === PFCLS.Spock && j2 === PFCLS.Paper){return  "Spock is disproved by paper"}
    if (j1 === PFCLS.Lizard && j2 === PFCLS.Scissors){return "Lizard is decapited by scissors"}

    if (j1 === PFCLS.Rock && j2 === PFCLS.Lizard){return  "Rock crushes lizard"}
    if (j1 === PFCLS.Paper && j2 === PFCLS.Spock){return  "Paper disproves Spock"}
    if (j1 === PFCLS.Scissors && j2 === PFCLS.Lizard){return "Scissors decapitates lizard"}
    if (j1 === PFCLS.Lizard && j2 === PFCLS.Paper){return "Lizard eats paper"}
    if (j1 === PFCLS.Lizard && j2 === PFCLS.Spock){return "Lizard poisons Spock"}
    if (j1 === PFCLS.Spock && j2 === PFCLS.Rock){return  "Spock vaporizes rock"}
    if (j1 === PFCLS.Spock && j2 === PFCLS.Scissors){return  "Spock smashes scissors"} 
    if (j1 === j2) {return "Equality"}
    else return ""      
}


export function reglesPoke (j1 : Poke , j2 : Poke)  : string {
    if (j1 === Poke.Squirtle && j2 === Poke.Bulbasaur ){return "Squirtle is drunk by Bulbasaur " }
    if (j1 === Poke.Charmander  && j2 === Poke.Squirtle){return "Charmander is extinguished by Squirtle" }
    if (j1 === Poke.Bulbasaur  && j2 === Poke.Charmander ){return "Charmander is burnt by Bulbasaur "}
    if (j1 === j2) {return "Equality"}
    if (j1 === Poke.Bulbasaur  && j2 === Poke.Squirtle){ return "Bulbasaur drink Squirtle"}
    if (j1 === Poke.Squirtle && j2 === Poke.Charmander ){return "Squirtle extinguishes Charmander "}
    if (j1 === Poke.Charmander  && j2 === Poke.Bulbasaur ){return "Charmander burns Bulbasaur "}
    else return ""      
}


export const randomEnumValue = (enumeration: any) => {
    const values = Object.keys(enumeration);
    const enumKey = values[Math.floor(Math.random() * values.length)];
    return enumeration[enumKey];
  }

 